module.exports = __webpack_public_path__ + "static/img/end.1695f315.png";